import React, {ReactEventHandler, useCallback, useEffect, useMemo} from 'react'
import {VideoFilePlayerProps} from './VideoFilePlayerProps'

export default function VideoFilePlayer({
  videoRef,
  videoFile,
  onVideoLoaded,
  ...rest
}: VideoFilePlayerProps) {
  const selfUrl = useMemo(() => URL.createObjectURL(videoFile), [videoFile])

  const handleVideoLoaded = useCallback<ReactEventHandler<HTMLVideoElement>>(
    (event) => {
      if (!selfUrl) return

      const {
        videoWidth,
        videoHeight,
        duration,
      } = event.target as HTMLVideoElement

      onVideoLoaded &&
        onVideoLoaded(
          {
            height: videoHeight,
            width: videoWidth,
            duration,
          },
          selfUrl,
        )
    },
    [onVideoLoaded, selfUrl],
  )

  useEffect(
    () => () => {
      if (selfUrl) URL.revokeObjectURL(selfUrl)
    },
    [selfUrl],
  )

  return (
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <video
      autoPlay={false}
      ref={videoRef}
      src={selfUrl}
      onLoadedData={handleVideoLoaded}
      {...rest}
    />
  )
}
